import React from "react";
import { useTranslation } from "react-i18next";
import { FORM_ITEM_TEXT_AREA } from "../../../../../components/Form/FormItems/FormItemTextArea";
import Tooltip from "../../../../../components/Tooltip";
import { ReportSectionWrapper } from "../ReportSectionWrapper";

export const ReportManagementSummary = ({ form, type, hasError, data, basicDataSaved }) => {
  const { t } = useTranslation();

  const fields = [
    {
      type: FORM_ITEM_TEXT_AREA,
      max: 4000,
      name: "management_summary",
      customLabel: (
        <div className="flex flex-items-center">
          <span className="mr-10">{t("ior.new_report.management_summary")}</span>
          <Tooltip title={t("ior.new_report.management_summary_tooltip")}>
            <i className="ti-info-alt fs-14" />
          </Tooltip>
        </div>
      ),
      placeholder: "ior.new_report.management_summary_placeholder"
    }
  ];

  return (
    <ReportSectionWrapper
      form={form}
      type={type}
      hasError={hasError}
      data={data}
      basicDataSaved={basicDataSaved}
      fields={fields}
      sectionTitleKey="ior.new_report.section_management_summary"
      sectionTooltipKey="ior.new_report.section_management_summary_popover"
      successMessageKey="ior.new_report.notifications.management_summary_saved"
      errorMessageKey="ior.new_report.notifications.management_summary_not_saved"
    />
  );
};
